import expireIn from 'lib/redux-persist-transform'
import { getPersistConfig } from 'redux-deep-persist'
import { MigrationManifest } from 'redux-persist'
import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import data from './data'

const expireInValue = 30 * 60 * 1000
const expirationKey = 'pwaExpirationKey'

const persistConfig = getPersistConfig({
  key: 'pwa',
  storage,
  rootReducer: data,
  transforms: [expireIn(expireInValue, expirationKey, false)],
})

export const reducer = persistReducer(persistConfig, data)
